<div class="cookie-popup" #cookiePopup *ngIf="show">
  <ng-container *ngIf="!showFullSettings">
    <div class="cookie-popup__content">
      To effectively show you the right experience and to help our brands
      optimise the content you see, we store cookies in your browser.
    </div>
    <div class="cookie-popup__action">
      <a class="settings-btn" (click)="showSettings()">Settings</a>
      <a class="accept-btn" (click)="acceptAll()">Accept All</a>
    </div>
  </ng-container>
  <ng-container *ngIf="showFullSettings">
    <div class="cookie-popup__content">
      <p>
        The cookies that are categorized as "Essentials" are required for
        enabling the basic functionalities of the site. <br /><br />We also use
        third-party cookies that help our brands analyze how you use this
        website and therefore optimise the experience you see. These cookies
        will only be stored in your browser with your prior consent.
      </p>
      <div class="cookie-item-line">
        <label>Essentials</label>
        <input type="checkbox" disabled [checked]="cookieSettings.firstParty" />
      </div>
      <div class="cookie-item-line">
        <label>
          <a
            target="_blank"
            href="https://support.google.com/analytics/answer/6004245"
            >Google Analytics</a
          >
        </label>
        <input
          type="checkbox"
          [checked]="cookieSettings.googleAnalytics"
          (change)="
            cookieSettings.googleAnalytics = !cookieSettings.googleAnalytics
          "
        />
      </div>
    </div>
    <div class="cookie-popup__action">
      <span></span>
      <div>
        <a class="confirm-btn" (click)="confirmSelection()">Confirm</a>
        <!-- <a class="accept-btn" (click)="acceptAll()">Accept All</a> -->
      </div>
    </div>
  </ng-container>
</div>
